import { useCallback, useState } from "react";
import { format } from "date-fns";

import { makeGetApiCall } from "../../shared/makeApiCall";

function extractErrorMessage(data) {
  if (!data) return "We could not load the dashboard.";
  if (typeof data.message === "string") return data.message;
  if (data.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors).flat()[0];
    if (typeof first === "string") return first;
  }
  return "We could not load the dashboard.";
}

/**
 * Live-state panels do not use the date range, but the API still validates from/to.
 * Send today for both so validation passes.
 */
function todayIso() {
  return format(new Date(), "yyyy-MM-dd");
}

export function useDashboardViewModel(logout) {
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setFetchError(null);

    const day = todayIso();
    const qs = new URLSearchParams({ from: day, to: day }).toString();
    const result = await makeGetApiCall(`operations-dashboard/activity?${qs}`);

    if (result.success) {
      setActivity(result.data);
    } else {
      setActivity(null);
      if (result.errorStatus === 401) {
        logout?.();
      }
      setFetchError(extractErrorMessage(result.data));
    }

    setLoading(false);
  }, [logout]);

  return {
    activity,
    loading,
    fetchError,
    refresh,
  };
}
